// src/components/Header.js

import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';

function Header() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isServicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  const menuRef = useRef(null);

  // Toggle mobile menu
  const handleMenuToggle = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && 
          !event.target.closest('.menu-toggle')) {
        setMobileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Modify handleLinkClick to also close the services menu
  const handleLinkClick = () => {
    setMobileMenuOpen(false);
    setServicesOpen(false);
  };

  // Add this handler
  const handleServicesTriggerClick = (e) => {
    // Si c'est un événement (venant du Link desktop), empêcher la navigation
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setServicesOpen(!isServicesOpen);
  };

  // Add check for active services
  const isServicesActive = location.pathname.startsWith('/services/');

  // Open services menu automatically if on a service page and mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen && isServicesActive) {
      setServicesOpen(true);
    } else if (!isMobileMenuOpen) {
      // Close services menu when mobile menu closes
      setServicesOpen(false);
    }
  }, [isMobileMenuOpen, isServicesActive]);

  // Close services menu when navigating away (only if not opening mobile menu)
  useEffect(() => {
    if (!isMobileMenuOpen) {
      setServicesOpen(false);
    }
  }, [location, isMobileMenuOpen]);

  return (
    <header className={`header ${isMobileMenuOpen ? 'menu-open' : ''}`}>
      {isMobileMenuOpen && (
        <div 
          className="menu-overlay" 
          onClick={handleMenuToggle}
          aria-label="Close menu"
        ></div>
      )}
      <nav className="navbar">
        <button
          className={`menu-toggle ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={handleMenuToggle}
          aria-label="Toggle navigation menu"
        >
          <span className="hamburger"></span>
        </button>
        <div className="logo">
          <Link to="/">Taxi<span className="logo-highlight">VD</span></Link>
        </div>
        <ul ref={menuRef} className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" onClick={handleLinkClick} className={location.pathname === '/' ? 'active' : ''}>
              Accueil
            </Link>
          </li>
          <li className="services-dropdown">
            <Link 
              to="/services" 
              className={`services-trigger services-trigger-desktop ${isServicesOpen || isServicesActive ? 'active' : ''}`}
              onClick={(e) => {
                handleServicesTriggerClick(e);
              }}
            >
              Services
            </Link>
            <span 
              className={`services-trigger services-trigger-mobile ${isServicesOpen || isServicesActive ? 'active' : ''}`}
              onClick={handleServicesTriggerClick}
            >
              Services
            </span>
            <div className={`mega-menu ${isServicesOpen ? 'active' : ''}`}>
              <div className="mega-menu-content">
                <Link 
                  to="/services/courses-scolaires" 
                  onClick={handleLinkClick}
                  className={location.pathname === '/services/courses-scolaires' ? 'active' : ''}
                >
                  Courses Scolaires
                </Link>
                <Link 
                  to="/services/navette-aeroport" 
                  onClick={handleLinkClick}
                  className={location.pathname === '/services/navette-aeroport' ? 'active' : ''}
                >
                  Navette Aéroport
                </Link>
                <Link 
                  to="/services/stations-ski" 
                  onClick={handleLinkClick}
                  className={location.pathname === '/services/stations-ski' ? 'active' : ''}
                >
                  Stations de Ski
                </Link>
                <Link 
                  to="/services/transport-colis" 
                  onClick={handleLinkClick}
                  className={location.pathname === '/services/transport-colis' ? 'active' : ''}
                >
                  Transport de Colis
                </Link>
                <Link 
                  to="/services/transport-medical" 
                  onClick={handleLinkClick}
                  className={location.pathname === '/services/transport-medical' ? 'active' : ''}
                >
                  Transport Médical
                </Link>
                <Link 
                  to="/services/mobilite-reduite" 
                  onClick={handleLinkClick}
                  className={location.pathname === '/services/mobilite-reduite' ? 'active' : ''}
                >
                  Mobilité Réduite
                </Link>
              </div>
            </div>
          </li>
          <li>
            <Link to="/permis" onClick={handleLinkClick} className={location.pathname === '/permis' ? 'active' : ''}>
              Permis
            </Link>
          </li>
          <li>
            <Link 
              to="/job" 
              onClick={handleLinkClick} 
              className={location.pathname === '/job' ? 'active' : ''}
            >
              Emploi
            </Link>
          </li>
          <li>
            <Link to="/quote" onClick={handleLinkClick} className={location.pathname === '/quote' ? 'active' : ''}>
              Devis
            </Link>
          </li>
        </ul>
        <div className="contact-buttons">
          <a href="tel:+41797774444" className="contact-number">
            <FaPhoneAlt className="contact-icon" />
            <span className="phone-text">+41 79 777 44 44</span>
          </a>
          <a 
            href="https://wa.me/41797774444" 
            className="contact-whatsapp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp className="whatsapp-icon" />
          </a>
        </div>
      </nav>
    </header>
  );
}

export default Header;
